import React, { useState, useEffect, useCallback } from 'react';
import { Layout, Menu } from 'antd';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { MaskOverlay, Burger } from '../../';
import { allowInsightsRoles, SIDEBAR_DRAWER_SIZE, URLS, USER_ROLES } from '../../../constants/constants';
import { sidebarTabs } from './sidebarMock';
import { BillingIcon } from '../../../assets';
import { useWindowSize } from '../../../hooks/useWindowSIze';

import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation';
import { connect } from 'react-redux';
import { ReportingIcon } from '../../../assets/svgs/reportingIcon';
import { useSelector } from 'react-redux';

const { Sider } = Layout;

const renderTabs = ({ role, location, handleCloseMask, isViewDashboardMode, enableInsights, collapsed, parentOrgId }) => {

  //todo: have to remove this code in future
  if (USER_ROLES[role]) {
    if (enableInsights && allowInsightsRoles.includes(role)) {
      const alreadyExists = sidebarTabs[role].some(
        (tab) => tab.path === URLS.REPORTING
      );
      
      if (!alreadyExists) {
        const insightTab = {
          id: 8,
          path: URLS.REPORTING,
          title: 'Insights',
          Icon: ReportingIcon,
        };

        sidebarTabs[role].splice(4, 0, insightTab);
      }
    }

    const tabs = sidebarTabs[role].filter((tab) => tab.path !== URLS.HO_BILLING);

    if (role === USER_ROLES.HO_ADMIN && isViewDashboardMode && parentOrgId) {
      const prefsIndex = tabs.findIndex((tab) => tab.path === URLS.PREFERENCES);
      const insertAt = prefsIndex >= 0 ? prefsIndex : tabs.length;
      tabs.splice(insertAt, 0, { id: 10, path: URLS.HO_BILLING, title: 'Billing', Icon: BillingIcon, beta: true });
    }

    if (role === USER_ROLES.ENTERPRISE_ADMIN && isViewDashboardMode) {
      const prefsIndex = tabs.findIndex((tab) => tab.path === URLS.PREFERENCES);
      const insertAt = prefsIndex >= 0 ? prefsIndex : tabs.length;
      tabs.splice(insertAt, 0, { id: 10, path: URLS.HO_BILLING, title: 'Billing', Icon: BillingIcon, beta: true });
    }

    return tabs.map((tab) => ({
      key: tab.id,
      icon: (
        <span>
          <tab.Icon />
        </span>
      ),
      className: classnames({
        'ant-menu-item-selected': location?.pathname.includes(tab.path),
        [styles.customMenuItem]: true,
      }),
      label: (
        <NavLink to={tab.path} className={({ isActive }) => (isActive ? styles.active : null)}
          onClick={handleCloseMask}>
          <span className={tab.beta && !collapsed ? styles.menuTitleRow : ''}>
            {tab.title}
            {tab.beta && !collapsed && <span className={styles.betaBadge}>BETA</span>}
          </span>
        </NavLink>
      ),
    }));
  } else return [];
};

const Sidebar = ({ role, isViewDashboardMode, parentOrgId }) => {
  const [collapsedWidth, setCollapsedWidth] = useState('');
  const [expandWidth, setExpandWidth] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const size = useWindowSize();
  const navigate = Navigation();
  const enableInsights = useSelector((state) => state.authorization?.user?.orgAddons?.insightsEnabled);

  useEffect(() => {
    if (size[0] > SIDEBAR_DRAWER_SIZE.BREAKPOINT) {
      setCollapsedWidth(SIDEBAR_DRAWER_SIZE.COLLAPSED_WIDTH);
      setExpandWidth(SIDEBAR_DRAWER_SIZE.DESKTOP_EXPAND_WIDTH);
      return setIsMobileView(false);
    }
    setCollapsedWidth(0);
    setExpandWidth(SIDEBAR_DRAWER_SIZE.MOBILE_EXPAND_WIDTH);
    setIsMobileView(true);

    return;
  }, [size]);

  useEffect(() => {
    if (size[0] < SIDEBAR_DRAWER_SIZE.BREAKPOINT + 1) {
      return setIsMobileView(true);
    }
    setIsMobileView(false);
    return;
  }, [size]);

  useEffect(() => { setCollapsed(true); return; }, [navigate?.location]);

  const handleOpenBurgerMenu = useCallback(() => setCollapsed(!collapsed), [collapsed]);

  const handleCloseSidebar = () => {
    if (isMobileView) return;
    setCollapsed(true);
  };

  const handleOpenSidebar = () => {
    if (isMobileView) return;
    setCollapsed(false);
  };

  const handleCloseMask = useCallback(() => {
    setCollapsed(true);
  }, [setCollapsed]);

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        className={styles.sidebar}
        onMouseEnter={handleOpenSidebar}
        onMouseLeave={handleCloseSidebar}
        width={expandWidth}
        collapsedWidth={collapsedWidth}
        trigger={null}>
        <Menu
          theme='dark'
          mode='inline'
          multiple={false}
          selectable={false}
          inlineIndent={isMobileView ? 12 : 24}
          items={renderTabs({
            role,
            location: navigate?.location,
            handleCloseMask,
            isViewDashboardMode,
            enableInsights,
            collapsed,
            parentOrgId,
          })}
        />
      </Sider>
      <Burger onClick={handleOpenBurgerMenu} collapsed={collapsed} />
      <MaskOverlay onClick={handleCloseMask} drawerIsOpen={isMobileView && !collapsed} />
    </>
  );
};

const mapStateToProps = (state) => ({
  isViewDashboardMode: state?.authorization?.viewDashboardMode?.active,
  role: state?.authorization?.role,
  parentOrgId: state?.authorization?.viewDashboardMode?.parentOrgId,
});


export default connect(mapStateToProps, null)(Sidebar);


